import React, { useCallback, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { FaArrowRight } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const MINIMUM_LOCATION_CHARS = 5;
const MINIMUM_SKU_CHARS = 10;

const LocationFilters = ({ locationFilters, setLocationFilters }) => {
    const [filters, setFilters] = useState(locationFilters);
    const [filteringEnabled, setFilteringEnabled] = useState(false);

    const handleSubmit = useCallback(
        (event) => {
            event.preventDefault();
            setLocationFilters(filters);
        },
        [filters, setLocationFilters]
    );

    const handleTextChange = useCallback((id, value) => {
        setFilters((oldFilters) => {
            const newFilters = {
                ...oldFilters,
                [id]: value,
            };

            return newFilters;
        });
    }, []);

    useEffect(() => {
        const checkFilterButtonEnabled = () => {
            if (filters.locationSearch.length >= MINIMUM_LOCATION_CHARS || 
                filters.skuSearch.length >= MINIMUM_SKU_CHARS
            ) {
                setFilteringEnabled(true);
            }
            else {
                setFilteringEnabled(false);
            }
        };
        checkFilterButtonEnabled();
    }, [filters]);

    useEffect(() => {
        setFilters(locationFilters);
    }, [locationFilters])

    return (
        <div className="locationFilters w-100 h-100 p-3 pt-1">
            <Form
                className="h-100"
                validated={false}
                onSubmit={(event) => handleSubmit(event)}
            >
                <Form.Group className="mt-2">
                    <Form.Label>Ingresa una ubicación o un SKU para buscar ubicaciones</Form.Label>

                    <Row>
                        {/*locationFilters.dateRangeOptions ? (
                            <Col md={2}>
                                <DateRangeFilter
                                    filters={filters}
                                    setFilters={setFilters}
                                    fieldName="Fecha modificación"
                                    dateRangeOptions={locationFilters.dateRangeOptions}
                                />
                            </Col>
                        ) : null*/}

                        <Col md={6}>
                            <InputGroup className="my-1">
                                <InputGroup.Text>
                                    Ubicación
                                </InputGroup.Text>
                                <Form.Control
                                    className="mt-0"
                                    id="locationSearch"
                                    type="text"
                                    placeholder={"Mínimo " + MINIMUM_LOCATION_CHARS + " carácteres"}
                                    onChange={(event) => handleTextChange("locationSearch", event.currentTarget.value)}
                                />
                            </InputGroup>
                        </Col>
                        <Col md={5}>
                            <InputGroup className="my-1">
                                <InputGroup.Text>
                                    SKU
                                </InputGroup.Text>
                                <Form.Control
                                    className="mt-0"
                                    id="sku"
                                    type="text"
                                    placeholder={"Mínimo " + MINIMUM_SKU_CHARS + " carácteres o una ubicación"}
                                    onChange={(event) => handleTextChange("skuSearch", event.currentTarget.value)}
                                />
                            </InputGroup>
                        </Col>

                        <Col className="align-self-start text-end" md={1}>
                            <Button
                                className="w-100"
                                type="submit"
                                variant="primary"
                                disabled={!filteringEnabled}
                            >
                                <FaArrowRight />
                            </Button>
                        </Col>
                    </Row>
                </Form.Group>
            </Form>
        </div>
    );
};

export default LocationFilters;
